import { render, staticRenderFns } from "./ActivationsChart.vue?vue&type=template&id=9a12aff8"
import script from "./ActivationsChart.vue?vue&type=script&lang=js"
export * from "./ActivationsChart.vue?vue&type=script&lang=js"
import style0 from "./ActivationsChart.vue?vue&type=style&index=0&id=9a12aff8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports